import { Maintenance, MaintenanceType } from '@repo/types';
import { makeRequest } from './base';

export const getMaintenance = (type: MaintenanceType): Promise<Maintenance> => {
  return makeRequest('get', `/api/admin/maintenance/`, { params: { type } });
};

export const createMaintenance = (
  data: Partial<Maintenance>,
): Promise<Maintenance> => {
  return makeRequest('post', `/api/admin/maintenance/`, { ...data });
};

export const updateMaintenance = (
  data: Partial<Maintenance & { id: string }>,
): Promise<Maintenance> => {
  return makeRequest('patch', `/api/admin/maintenance/${data.id}/`, {
    ...data,
  });
};
